import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../../api/client";

export const guardianStatusKey = id => ["guardian-verification", id];
export const useGuardianVerification = (id) => useQuery({
  queryKey: guardianStatusKey(id),
  queryFn: () => apiFetch("/guardian/verification/status"),
  enabled: Boolean(id),
  staleTime: 0,
  retry: false,
  refetchInterval: query => {
    const status = query.state.data;
    return status?.required && status.state !== "verified" ? 5000 : false;
  },
  refetchIntervalInBackground: false,
});
